import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles(
  ({ typography, spacing, palette, transitions }) => ({
    container: {
      /* disable default outline */
      '& *:focus': {
        outline: 'none',
      },
      /* style main text input */
      '& .form-control': {
        fontFamily: typography.fontFamily,
        fontSize: typography.fontSize,
        padding: spacing(3.5, 0, 3.5, 12),
        width: '100%',
        border: `1px solid ${palette.grey[200]}`,
        transition: transitions.create(['border']),
        overflow: 'hidden',
        borderRadius: spacing(1),
        /* change border to primary main everywhere (siblings) where this is needed when input state: focus */
        '&:focus': {
          border: `1px solid ${palette.primary.main}`,
          outline: 'none',
        },
        '&:focus ~ .flag-dropdown': {
          border: `1px solid ${palette.primary.main}`,
        },
        /* style input placeholder */
        '&::placeholder': {
          fontFamily: typography.fontFamily,
          fontSize: typography.fontSize,
          fontWeight: 400,
          color: `rgba(0, 0, 0, 0.54)`,
        },
      },
      /* change border to darker everywhere where this is needed when container state: hover */
      '&:hover': {
        '& .form-control': {
          border: `1px solid ${palette.grey[300]}`,
        },
        '& .flag-dropdown': {
          border: `1px solid ${palette.grey[300]}`,
        },
      },
      /* style flag button on the left */
      '& .flag-dropdown': {
        borderTopLeftRadius: spacing(1),
        borderBottomLeftRadius: spacing(1),
        border: `1px solid ${palette.grey[200]}`,
        boxShadow: `-4px 0px 0px 4px ${palette.common.white}`, // hiding strange corner pixels
        backgroundColor: palette.grey[200],
        transition: transitions.create(['border', 'background-color']),
        /* style inner element inside flag button */
        '& .selected-flag': {
          borderTopLeftRadius: spacing(1),
          borderBottomLeftRadius: spacing(1),
          transition: transitions.create(['border', 'background-color']),
          width: 76,
          paddingLeft: spacing(2.2),
          backgroundColor: palette.grey[200],
          '&:hover': {
            backgroundColor: palette.grey[100],
          },
          '& .arrow': {
            left: 36,
            borderLeft: `5px solid transparent`,
            borderRight: `5px solid transparent`,
            borderTop: `5px solid ${palette.grey[400]}`,
            '&.up': {
              borderTop: `none`,
              borderBottom: `5px solid ${palette.grey[400]}`,
            },
          },
        },
        /* style when state: open */
        '&.open': {
          borderTopLeftRadius: spacing(1),
          borderBottomLeftRadius: spacing(1),
          '& .selected-flag': {
            borderTopLeftRadius: spacing(1),
            borderBottomLeftRadius: spacing(1),
            backgroundColor: palette.grey[100],
          },
        },
      },
      /* style expandable list | ul li */
      '& .country-list': {
        margin: `5px 0`,
        padding: spacing(1, 0),
        boxShadow:
          'rgb(0 0 0 / 20%) 0px 2px 1px -1px, rgb(0 0 0 / 14%) 0px 1px 1px 0px, rgb(0 0 0 / 12%) 0px 1px 3px 0px;',
      },
      '& .country-list .flag': {
        left: 20, // slightly move flags to fit "countries" input field look
        transform: `scale(0.95)`, // slightly minify images to fit "countries" input field look
      },
      '& .country-list .country': {
        paddingLeft: 54, // slightly add padding left to whole row to fit "countries" input field look
        paddingTop: spacing(1), // slightly add padding top/bottom to whole row to fit "countries" input field look
        paddingBottom: spacing(1), // slightly add padding top/bottom to whole row to fit "countries" input field look
        fontFamily: typography.fontFamily,
        fontSize: typography.fontSize - 1,
        fontWeight: 400,
      },
    },
  })
);
